import { render, staticRenderFns } from "./myMap.vue?vue&type=template&id=06ba6c55&"
import script from "./myMap.vue?vue&type=script&lang=js&"
export * from "./myMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports